/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Apps_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Interactive apps built in this project's chats will appear here." |
*
* @param {Project_Apps_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_apps_empty_description = /** @type {((inputs?: Project_Apps_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Apps_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Interaktive Apps, die in den Chats dieses Projekts entstehen, erscheinen hier.")
	return /** @type {LocalizedString} */ ("Interactive apps built in this project's chats will appear here.")
});